module.exports = __webpack_public_path__ + "static/media/slightly-smiling-face.11ed31a2.svg";